import getDestination from "./getDestination";
import load from "./load";
import serialize from "./serialize";
var POST_HEADERS = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

var loadElement = function loadElement(element) {
  var url = getDestination(element);

  if (element.nodeName === 'A') {
    return load(url);
  } else if (element.nodeName === 'FORM') {
    var method = element.getAttribute('method');

    if (!method || method.toLowerCase() === 'get') {
      return load(url);
    }

    var body = serialize(element);
    return load(url, {
      method: method,
      body: body,
      headers: POST_HEADERS
    });
  } else {
    throw new Error("Unexpected nodename ".concat(element.nodeName, " for loadElement"));
  }
};

export default loadElement;